import { render } from "./NumberRecycleRecord.vue?vue&type=template&id=2edf39fe&scoped=true"
import script from "./NumberRecycleRecord.vue?vue&type=script&lang=js"
export * from "./NumberRecycleRecord.vue?vue&type=script&lang=js"

import "./NumberRecycleRecord.vue?vue&type=style&index=0&id=2edf39fe&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edf39fe"]])

export default __exports__